import { render, staticRenderFns } from "./PlayButton.vue?vue&type=template&id=fd4ffcb2&scoped=true&"
import script from "./PlayButton.vue?vue&type=script&lang=ts&"
export * from "./PlayButton.vue?vue&type=script&lang=ts&"
import style0 from "./PlayButton.vue?vue&type=style&index=0&id=fd4ffcb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4ffcb2",
  null
  
)

export default component.exports